import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { IconButton, Tooltip } from '@sumologic/yama-ds-components';

import Icon from '~/components/Icon/Icon';

const HoverDropDown = props => {
    const [open, setOpen] = useState(false);
    let buttonShown = props.showButton;
    if (!buttonShown) {
        const button = (
            <IconButton
                className={`menu-button-item menu-button-item-icon ${
                    props.extraClass || ''
                }`}
            >
                <Icon size="xl" type={props.icon} />
                {props.extraComponent}
            </IconButton>
        );
        buttonShown = props.tooltip ? (
            <Tooltip title={props.tooltip} placement="auto" arrow>
                {button}
            </Tooltip>
        ) : (
            button
        );
    }
    return (
        <div
            data-testid="hover-drop-down"
            className={`menu-item rounded-1 hover-dropdown ${
                open ? 'is' : 'not'
            }-open ${props.active ? 'active' : 'inactive'}`}
            onMouseOver={
                open
                    ? null
                    : () => {
                          setOpen(true);
                      }
            }
            onMouseLeave={
                open
                    ? () => {
                          setOpen(false);
                      }
                    : null
            }
        >
            {buttonShown}
            <div
                data-testid="dropdown-menu"
                className={`dropdown-menu dropdown-menu-${props.alignMenu}`}
            >
                {props.items?.map((item, index) =>
                    item ? (
                        <a
                            key={index}
                            className="dropdown-item"
                            href={item.href || '#'}
                            {...(item.testId
                                ? { 'data-sumo-test': item.testId }
                                : {})}
                            onClick={event => {
                                event.preventDefault();
                                event.stopPropagation();
                                setOpen(false);
                                item.onClick?.();
                                if (item.href) {
                                    window.location.href = item.href;
                                }
                            }}
                        >
                            {item.label}
                        </a>
                    ) : null
                )}
            </div>
        </div>
    );
};

HoverDropDown.propTypes = {
    icon: PropTypes.string.isRequired,
    alignMenu: PropTypes.oneOf(['left', 'right']),
    items: PropTypes.arrayOf(
        PropTypes.shape({
            href: PropTypes.string,
            onClick: PropTypes.func,
            label: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),
            testId: PropTypes.string
        })
    ),
    extraComponent: PropTypes.element,
    tooltip: PropTypes.node,
    extraClass: PropTypes.string,
    active: PropTypes.bool
};

export default HoverDropDown;
